import { Component, Inject, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-demo-report-modal',
    templateUrl: './demo-report-modal.component.html',
    styleUrls: ['./demo-report-modal.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DemoReportModalComponent implements OnInit, OnDestroy {

    constructor(
        private dialogRef: MatDialogRef<DemoReportModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private router: Router
    ) { }

    ngOnInit() {
        // Listen for messages from the iframe
        window.addEventListener('message', this.handleIframeMessage.bind(this));

    }

    ngOnDestroy() {
        // Clean up the event listener
        window.removeEventListener('message', this.handleIframeMessage.bind(this));
    }

    private handleIframeMessage(event: MessageEvent) {
        // Check if the message is from our iframe and contains the navigation command
        if (event.data === 'navigateToDashboard') {
            this.navigateToDashboard();
        }

        if (event.data === 'navigateToCompanyWebsite') {
            this.navigateToCompanyWebsite();
        }
    }

    private navigateToDashboard() {
        // Close the modal first
        this.dialogRef.close();
        // Navigate to dashboard
        this.router.navigate(['/dashboard']);
    }

    private navigateToCompanyWebsite() {
        // Close the modal first
        this.dialogRef.close();
        // Navigate to company website
        window.open('https://www.raoinformationtechnology.com', '_blank');
    }

    closeModal() {
        this.dialogRef.close();
    }
}
